/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/**
 * Sprint 1 — Passwordless Magic Link (email) client.
 *
 * Two-step flow:
 *  1) requestMagicLink(email) → backend emails a single-use link (/auth/magic?token=…)
 *  2) verifyMagicLink(token)  → consumes token; backend sets httpOnly sn_auth cookie
 *                              and returns the user profile.
 */

export async function requestMagicLink(email) {
  const res = await api.post('/auth/magic-link/request', { email });
  return res.data; // { ok, message, dev_magic_url? (dev only) }
}

export async function verifyMagicLink(token) {
  const res = await api.get('/auth/magic-link/verify', { params: { token } });
  return res.data; // { ok, user }
}
